<div class="banner" fetchpriority="high" [ngStyle]="{'backgroundImage': imageWebp ? 'url('+imageWebp+')' : 'url('+image+')', '--focus-x': focusX || '50%', '--focus-y': focusY || '15%'}">
	<div class="banner-text" *ngIf="topText || topText2 || mainText">
		<p class="top-text" *ngIf="topText">{{topText}}</p>
		<p class="top-text top-text-2" *ngIf="topText2">{{topText2}}</p>
		<p class="main-text" *ngIf="mainText">{{mainText}}</p>
	</div>
	<p *ngIf="text && !topText && !mainText">{{text}}</p>
</div>
